import type { CookieCategoryValue } from ".";
import getConsentedGroups from "./getConsentedGroups";

const isConsentGranted = (cookieId: CookieCategoryValue): Boolean => {
	return window.OnetrustActiveGroups ? getConsentedGroups().includes(cookieId) : false;
};

export default isConsentGranted;
